import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import styles from '../../../../styles/icons/logos/img.module.scss';
import src from '../../../../img/logo-france.png';

const propTypes = {
    // color: PropTypes.string,
    className: PropTypes.string,
};

const defaultProps = {
    // color: 'currentColor',
    className: null,
};

const UrbaniaCrackedIcon = ({ className }) => (
    <img
        src={src}
        className={classNames([
            styles.container,
            {
                [className]: className !== null,
            },
        ])}
        alt="URBANIA France"
    />
);

UrbaniaCrackedIcon.propTypes = propTypes;
UrbaniaCrackedIcon.defaultProps = defaultProps;

export default UrbaniaCrackedIcon;
